import { AppBar, Box, Toolbar } from "@mui/material";
import TokenSelector from "./TokenSelector";
import FormatButtons from "./FormatButtons";
import JustifyButtons from "./JustifyButtons";
import ListButtons from "./ListButtons";
import IndentButtons from "./IndentButtons";
import ActionButtons from "./ActionButtons";
import InsertButtons from "./InsertButtons";
import ColorButton from "./ColorButton";
import { Token } from "../types/content-editor-types";

type Props = {
    onCommand: (command: string, argument?: string) => void;
    tokens: Token[];
};

const ContentEditorToolbar = ({ onCommand, tokens }: Props) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <AppBar position='relative'>
                <Toolbar variant='dense'>
                    <TokenSelector tokens={tokens} onCommand={onCommand} />
                    <FormatButtons onCommand={onCommand} />
                    <JustifyButtons onCommand={onCommand} />
                    <ListButtons onCommand={onCommand} />
                    <IndentButtons onCommand={onCommand} />
                    <ActionButtons onCommand={onCommand} />
                    <InsertButtons onCommand={onCommand} />
                    <ColorButton onCommand={onCommand} />
                </Toolbar>
            </AppBar>
        </Box>
    );
};

export default ContentEditorToolbar;
